import { ComponentProps, forwardRef, Ref, useState } from "react";
import { Icon } from "../Common/Icons/LucideIcons";
import { ReactHookFormTextInput as TextInput } from "./Text";

type Props = Omit<ComponentProps<typeof TextInput>, "type" | "postfix">;

export const ReactHookFormPasswordInput = forwardRef(
  ({ name, size = "medium", ...props }: Props, ref: Ref<HTMLInputElement>) => {
    const [showPassword, setShowPassword] = useState(false);

    const handleShowPassword = () => {
      setShowPassword(!showPassword);
    };

    return (
      <TextInput
        {...props}
        ref={ref}
        name={name}
        type={showPassword ? "text" : "password"}
        postfix={
          <Icon
            iconName={showPassword ? "eye" : "eye-off"}
            color={"contentSecondary"}
            size={16}
            onClick={handleShowPassword}
          />
        }
      />
    );
  },
);
